interface NebariLogoGlyphProps {
  size?: number;
  color?: string;
}

/** The brand mark — a stacked bonsai canopy + trunk + base shadow. Matches
 *  the SVG used in the design's chrome.jsx exactly. */
export default function NebariLogoGlyph({
  size = 20,
  color = 'currentColor',
}: NebariLogoGlyphProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      style={{ display: 'block', flexShrink: 0 }}
      aria-hidden="true"
    >
      <ellipse cx="12" cy="8" rx="6" ry="3" />
      <ellipse cx="8.5" cy="11" rx="4.5" ry="2.5" />
      <ellipse cx="15.5" cy="11" rx="4.5" ry="2.5" />
      <rect x="11" y="13" width="2" height="6" rx="1" />
      <ellipse cx="12" cy="20" rx="6" ry="1.2" opacity=".25" />
    </svg>
  );
}
